import { atom, useAtom } from 'jotai';

type Location = {
  longitude: number;
  latitude: number;
};

type MapboxSessionToken = {
  token: string;
  expiredAt: number;
};

type UseSearchedLocation = {
  searchedLocation: Location | undefined;
  setSearchedLocation: (searchedLocation: Location | undefined) => void;
  mapboxSessionToken: MapboxSessionToken | undefined;
  setMapboxSessionToken: (sessionToken: MapboxSessionToken | undefined) => void;
};

const searchedLocationAtom = atom<Location | undefined>(undefined);

const mapboxSessionTokenAtom = atom<MapboxSessionToken | undefined>(undefined);

const useSearchedLocation = (): UseSearchedLocation => {
  const [searchedLocation, setSearchedLocation] = useAtom(searchedLocationAtom);

  const [mapboxSessionToken, setMapboxSessionToken] = useAtom(
    mapboxSessionTokenAtom
  );

  return {
    searchedLocation,
    setSearchedLocation,
    mapboxSessionToken,
    setMapboxSessionToken,
  };
};

export { useSearchedLocation };
